import * as yup from "yup";
import { CountryDetails } from "./types";

const pointPropertiesSchema = yup.object({
  name: yup.string().min(1).required(),
});

/** Extracts country details from a Highcharts point. */
export const extractCountryDetailsFromPoint = (
  point: Highcharts.Point & {
    "hc-key"?: string;
    value?: number | null;
    properties?: { name?: string };
  }
): CountryDetails | null => {
  const countryKey = point["hc-key"];

  if (!countryKey) {
    return null;
  }

  return {
    countryKey,
    countryName: pointPropertiesSchema.isValidSync(point.properties)
      ? point.properties.name
      : countryKey,
    countryColor: typeof point.color === "string" ? point.color : "#000000",
    chatsCount: typeof point.value === "number" ? point.value : 0,
  };
};

const REGIONAL_INDICATOR_OFFSET = 127397;

/** Maps ISO 3166-1 alpha-2 (e.g. hc-key) to a flag emoji */
export const countryCodeToFlagEmoji = (isoAlpha2: string): string => {
  const upper = isoAlpha2.trim().toUpperCase();

  if (upper.length !== 2 || !/^[A-Z]{2}$/.test(upper)) {
    return "";
  }

  return String.fromCodePoint(
    ...[...upper].map((ch) => REGIONAL_INDICATOR_OFFSET + ch.charCodeAt(0))
  );
};
